export function HeadingSmall({
  title,
  description,
}: {
  title: string
  description?: string
}) {
  return (
    <header>
      <h3
        className="font-display mb-0.5 text-base font-bold tracking-wider uppercase"
        style={{
          color: "var(--accent)",
          textShadow:
            "0 0 4px oklch(0.8 0.16 85 / 0.25), 0 0 16px oklch(0.8 0.3 145 / 0.12), 0 1px 0 oklch(0.55 0.1 85), 0 1px 3px oklch(0 0 0 / 0.4)",
        }}
      >
        {title}
      </h3>
      {description && (
        <p className="text-muted-foreground text-sm">{description}</p>
      )}
    </header>
  )
}
